import { render, staticRenderFns } from "./HeaderText.vue?vue&type=template&id=48729b25&"
import script from "./HeaderText.vue?vue&type=script&lang=js&"
export * from "./HeaderText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports